module.exports = __webpack_public_path__ + "img/CheckmarkGreen.9981234a.svg";